var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('p',[_vm._v("Integrations")]),_c('v-btn',{on:{"click":_vm.loginGrowatt}},[_vm._v("Connect")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }